import { useParams } from 'react-router'

import type { ParameterRouteParams } from '../system/types'

/** Helper hook for retrieving the parameter definition ID from the query params.*/
export const useParameterDefinitionId = (): string => {
  const { parameterDefinitionId } = useParams<ParameterRouteParams>()

  if (!parameterDefinitionId) {
    throw new Error(`No parameter definition ID was found`)
  }

  return parameterDefinitionId
}
